import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../config/api';
import ClientLink from './ClientLink';
import { ShieldAlert, ChevronRight } from 'lucide-react';

// Staff dashboard: documents flagged as possibly tampered with that are
// waiting for review (GET /api/document-flags/summary), linking to the
// Flagged Documents page. Renders nothing when there are none open.
const FlaggedDocumentsCard = ({ className = 'mb-4' }) => {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(apiUrl('/api/document-flags/summary'), {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (!cancelled) setSummary(res.data);
      } catch { /* not available to this user, or no table yet */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!summary || !summary.open) return null;

  return (
    <div className={`${className} rounded-xl border border-rose-200 dark:border-rose-800/50 bg-rose-50 dark:bg-rose-900/20 p-4`}>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-2">
          <ShieldAlert size={18} className="text-rose-600 dark:text-rose-400" />
          <h3 className="text-sm font-semibold text-rose-900 dark:text-rose-200">
            {summary.open} document{summary.open === 1 ? '' : 's'} flagged as possibly tampered with
            {summary.open_high ? ` · ${summary.open_high} high risk` : ''}
          </h3>
        </div>
        <button
          type="button"
          onClick={() => navigate('/document-flags')}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold bg-rose-600 text-white hover:bg-rose-700"
        >
          Review them <ChevronRight size={14} />
        </button>
      </div>
      <ul className="divide-y divide-rose-100 dark:divide-rose-900/40">
        {(summary.recent || []).map((f) => (
          <li key={f.id} className="py-1.5 flex items-center justify-between gap-3 text-xs">
            <span className="min-w-0 truncate text-rose-900 dark:text-rose-200">
              <strong>{f.document_type || 'Document'}</strong> — <ClientLink clientId={f.client_id} name={f.client_name || 'Unknown client'} />
              <span className="text-rose-700 dark:text-rose-300"> · {(f.signals || [])[0]?.message || ''}</span>
            </span>
            <span className={`flex-shrink-0 px-2 py-0.5 rounded-full font-semibold ${f.risk_level === 'high' ? 'bg-rose-200 text-rose-800' : 'bg-amber-100 text-amber-800'}`}>
              {f.risk_level === 'high' ? 'High' : 'Medium'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FlaggedDocumentsCard;
